/**
*  Date    : 2023/02/15
*  Author  : Liuzijun
*  Declare : 学科学习力测评
*/
import Immutable from 'seamless-immutable';

import { DEFAULT_SUBJECT } from '@/routes/LearningAbility/utils';

export default {
  namespace: 'learning',
  state: Immutable({
    isLoaded: false, // 是否加载过
    subjectBanner: DEFAULT_SUBJECT,
    subjectIndex: 0,
    recommendValue: null // 推荐年级值
  }),
  reducers: {
    update: (state, { data, field }) => {
      return state.merge({ [field]: data });
    }
  },
  actions: {
    updateLoaded: data => ({
      type: 'learning/update',
      field: 'isLoaded',
      data
    }),
    updateIndex: data => ({
      type: 'learning/update',
      field: 'subjectIndex',
      data
    }),
    updateBanner: data => ({
      type: 'learning/update',
      field: 'subjectBanner',
      data
    }),
    updateRecommend: data => ({
      type: 'learning/update',
      field: 'recommendValue',
      data
    })
  }
};